import { parseTemplate } from 'url-template';
import ApiClient from '~/ApiClient';

import TherapeuticArea from './TherapeuticArea';

export interface Result {
	items: TherapeuticArea[];
}

export default async function findTherapeuticAreas(client: ApiClient, filter: string): Promise<Result> {
	const url = parseTemplate('analytics/autocomplete/therapeutic-areas{?filter}');
	const request = await client.fetch(url.expand({ filter }));
	const response = await request.json();
	return {
		items: response.items.map((item: { therapeuticArea: string }) => new TherapeuticArea(item.therapeuticArea)),
	};
}
